import { useEffect, useState } from 'react';

import { snakeToCamel } from '@shared/helpers';
import { getEstimateInformationQuery } from '@widgets/EstimateInformation/api/hooks/getEstimateInformationQuery';
import { useUpdatePurchaseSortMode } from '@widgets/EstimateInformation/api/hooks/useUpdatePurchaseSortMode';
import { useHandleEstimateInformationModal } from '@widgets/EstimateInformation/lib/hooks/useHandleEstimateInformationModal';
import {
    IEstimateInformationContext,
    Status,
} from '@widgets/EstimateInformation/model/types/types';

export const useEstimateInformation = () => {
    const {
        onCloseCreateEstimateModal,
        isOpenCreateEstimateModal,
        onOpenCreateEstimateModal,
        onHandleAddEmployeesModal,
        isOpenAddEmployeesModal,
        isOpenGanttModal,
        onCloseGanttModal,
        onOpenGanttModal,
    } = useHandleEstimateInformationModal();

    const { data, refetch, isPending } = getEstimateInformationQuery();
    const [status, setStatus] = useState<Status>(Status.DRAFT);

    const onSetStatus = (value: Status): void => {
        setStatus(value);
    };

    const [isActiveSingleListSorting, setIsActiveSingleListSorting] = useState(false);
    const updatePurchaseSortModeMutation = useUpdatePurchaseSortMode();
    useEffect(() => {
        if (data) {
            setIsActiveSingleListSorting(data?.purchasePageInSortMode);
            setStatus(snakeToCamel(data?.status?.code) as Status);
        }
    }, [data]);

    const onActiveSingleListSorting = async () => {
        const newValue = !isActiveSingleListSorting;
        setIsActiveSingleListSorting(newValue);
        await updatePurchaseSortModeMutation.mutateAsync(newValue);
        await refetch();
        window.location.reload();
    };

    const context: IEstimateInformationContext = {
        onCloseCreateEstimateModal,
        isOpenCreateEstimateModal,
        onOpenCreateEstimateModal,
        isActiveSingleListSorting,
        onActiveSingleListSorting,
        onHandleAddEmployeesModal,
        isOpenAddEmployeesModal,
        status,
        onSetStatus,
        isOpenGanttModal,
        onCloseGanttModal,
        onOpenGanttModal,
    };

    return {
        context,
        onOpenCreateEstimateModal,
        onCloseCreateEstimateModal,
        isOpenCreateEstimateModal,
        data,
        onHandleAddEmployeesModal,
        isOpenAddEmployeesModal,
        isOpenGanttModal,
        onCloseGanttModal,
        onOpenGanttModal,
        isPending,
    };
};
